import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Menu from "@/pages/Menu";
import Story from "@/pages/Story";
import Locations from "@/pages/Locations";
import LocationDetail from "@/pages/LocationDetail";
import GiftCards from "@/pages/GiftCards";
import Contact from "@/pages/Contact";
import Careers from "@/pages/Careers";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="menu" element={<Menu />} />
          <Route path="our-story" element={<Story />} />
          <Route path="about" element={<Navigate to="/our-story" replace />} />
          <Route path="locations" element={<Locations />} />
          <Route path="locations/:slug" element={<LocationDetail />} />
          <Route path="gift-cards" element={<GiftCards />} />
          <Route path="store" element={<Navigate to="/gift-cards" replace />} />
          <Route path="contact" element={<Contact />} />
          <Route path="careers" element={<Careers />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
